import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "arrow-left",
		d: "M9.3125 17.5947C9.19531 17.6729 9.07812 17.7119 8.96094 17.7119C8.80469 17.7119 8.72656 17.6729 8.64844 17.5947L0.40625 9.31348C0.289062 9.23535 0.25 9.15723 0.25 9.00098C0.25 8.88379 0.289062 8.7666 0.40625 8.68848L8.64844 0.407227C8.72656 0.329102 8.80469 0.290039 8.96094 0.290039C9.07812 0.290039 9.19531 0.329102 9.3125 0.407227L9.58594 0.719727C9.66406 0.797852 9.70312 0.915039 9.70312 1.03223C9.70312 1.18848 9.66406 1.30566 9.58594 1.38379L2.59375 8.33691H17.2812C17.3984 8.33691 17.5156 8.41504 17.5938 8.49316C17.6719 8.57129 17.75 8.68848 17.75 8.80566V9.19629C17.75 9.35254 17.6719 9.46973 17.5938 9.54785C17.5156 9.62598 17.3984 9.66504 17.2812 9.66504H2.59375L9.58594 16.6182C9.66406 16.7354 9.70312 16.8525 9.70312 16.9697C9.70312 17.126 9.66406 17.2041 9.58594 17.2822L9.3125 17.5947Z",
		fill: "currentColor"
	})
});
export default SvgArrowLeft;
